'use client';
import AppLayout from '@/components/AppLayout';
import NewSupplierContent from './components/NewSupplierContent';

export default function NewSupplierPage() {
  return (
    <AppLayout>
      <NewSupplierContent />
    </AppLayout>
  );
}
